import { useMemo } from 'react';

import { formatDateTime, DateTimeFormat } from '@occc-app/lib/date';

import { useRetailerNetworkTobaccoProgramMetricsOverview } from '../../hooks/use-retailer-network-tobacco-program-metrics-overview.hook';
import { getTobaccoPerformanceMetrics } from '../../retailer-network-performance-page/components/tobacco-performance-metric-builder';

type UseMetricsOverviewOptions = {
  retailerNetworkUuid: string;
  startDate: Date;
  endDate: Date;
};

export function useMetricsOverview(options: UseMetricsOverviewOptions) {
  const { retailerNetworkUuid, startDate, endDate } = options;

  const { data, error, loading } = useRetailerNetworkTobaccoProgramMetricsOverview({
    retailerNetworkUuidEquals: retailerNetworkUuid,
    dateFrom: formatDateTime(startDate, DateTimeFormat.DateDashed),
    dateTo: formatDateTime(endDate, DateTimeFormat.DateDashed),
  });

  return useMemo(
    () => ({
      data: data
        ? getTobaccoPerformanceMetrics(
            data.retailerNetworkTobaccoProgramMetricsOverview.performance,
            data.retailerNetworkTobaccoProgramMetricsOverview.previousPerformance,
          ).flat
        : undefined,
      error,
      loading,
    }),
    [data, error, loading],
  );
}
